<template>
	<div>
		<nav id="verticalMobile" v-if="mobile">
			<div class="wrap-vernav">
				<ul class="vernav-list flex">
					<li>
						<a href="/helpcenter" target="_blank">
							<span class="vernav-icon"><img :src="base_url+'/images/help-centre.svg'" alt="icon nav"></span>
							<p>Help <br> Center</p>
						</a>
					</li>
					<li>
						<a :href="app_url" target="_blank">
							<span class="vernav-icon"><img :src="base_url+'/images/community.svg'" alt="icon nav"></span>
							<p>Join <br> Community</p>
						</a>
					</li>
					<li>
						<a href="/helpcenter/topic/simulasi-kredit/">
							<span class="vernav-icon"><img class="calculator-svg" :src="base_url+'/images/calculator.svg'" alt="icon nav"></span>
							<p>Simulasi <br> Kredit</p>
						</a>
					</li>
					<li>
						<a href="/helpcenter/topic/layanan-bengkel/" target="_blank">
							<span class="vernav-icon"><img :src="base_url+'/images/service.svg'" alt="icon nav"></span>
							<p>Booking <br> Service</p>
						</a>
					</li>
					<li>
						<a href="/promo">
							<span class="vernav-icon"><img :src="base_url+'/images/promo.svg'" alt="icon nav"></span>
							<p>Cek <br> Promo</p>
						</a>
					</li>
				</ul>
				<a  @click="scrollToTop" class="back-to-top"><img :src="base_url+'/images/icon_arrow_up.svg'" alt="Back to Top"></a>
			</div>
		</nav>
		<!-- mobile -->

		<!-- desktop -->
	</div>
</template>

<script>
	import { isMobile } from 'mobile-device-detect';
    export default {
		data: function() {
			return{
                base_url:base_url,
                app_url:app_url,
                api_url:api_url,
				mobile: false
			}
		},
		created(){
			this.mobile = isMobile;
		},
        methods: {
			  scrollToTop() {
				const c = document.documentElement.scrollTop || document.body.scrollTop;
				if (c > 0) {
					window.requestAnimationFrame(this.scrollToTop);
					window.scrollTo(0, c - c / 8);
				}
				 console.log('scrolll');
			  },
        },
    }
</script>

<style lang="scss" scoped>
	#verticalNav{
		position: fixed;
		z-index: 100;
		top: 150px;
		right: 15px;
		max-width: 75px;
	}
	.wrap-vernav{
		position: relative;
	}
	.vernav-list:before{
		position: absolute;
		content: '';
		top: 0;
		left: 0;
		width: 100%;
		height: 9px;
		background-color: #E61B33;
	}
	.vernav-list{
		background-color: #fff;
		position: relative;
		text-align: center;
		padding: 0;
		margin: 0;
		list-style-type: none;
		padding-top: 20px;
		overflow: hidden;
		border: solid 1px #DBDBDB;
		border-radius: 10px;
		box-shadow: 8px 4px 25px 0px rgba(0, 0, 0, 0.1);
	}
	.vernav-list a{
		display: inline-block;
	}
	.vernav-list a:hover{
		 p{
			 color:#E61B33;
		 }

		 img{
			filter:invert(1) sepia(2) saturate(83) hue-rotate(25deg);
		}
	}
	.vernav-list li{
		padding: 0 7px;
		border-bottom: solid 1px #DBDBDB;
		margin-bottom: 15px;
	}
	.vernav-list li:last-child{
		margin-bottom: 0;
	}
	.vernav-list p{
		font-size: 10px;
		font-weight: 500;
		color: #727272;
		margin-top: 5px;
		margin-bottom: 0;
		padding-bottom: 15px;
	}
	.back-to-top{
		background-color: #fff;
		border-radius: 100px;
		position: absolute;
		bottom: -60px;
		left: 50%;
		display: block;
		width: 40px;
		height: 40px;
		margin:0 0 0 -20px;
		cursor: pointer;
		img{
			width: 100%;
		}
	}
	.back-to-top:hover{
		img{
		filter:invert(0) sepia(2) saturate(83) hue-rotate(25deg);
		}
	}
	// ==================================================  MOBILE RESPONSIVE
	@media (max-width: 490px){
        #verticalMobile{
			position: fixed;
			z-index: 900;
			bottom: 0;
			left: 0;
			right: 0;
			max-width: 100%;
		}
        .vernav-icon img{
            max-width: 20px;
        }
		.vernav-list{
			justify-content: space-around;
			border-radius: 0;
			padding-top: 10px;
				p{
					font-weight: 700;
                    font-size: 8px;
					color: #282828;
				}
				li{
					padding: 0;
					margin-bottom: 0;
					border-bottom: none;
				}
				&:before{
					display: none;
				}
		}
		.back-to-top {
			bottom: 100px;
			left: unset;
			right: 15px;
			width: 30px;
			height: 30px;
		}
    }
</style>
